import React from 'react';
import ReactDOM from 'react-dom/client';
import SecurityScanner from './SecurityScanner.tsx';

// Suppress ResizeObserver loop errors (harmless warning)
const errorHandler = (event: ErrorEvent) => {
  const errorMessage = event.message || '';
  if (errorMessage && errorMessage.includes('ResizeObserver loop')) {
    event.stopImmediatePropagation();
    event.stopPropagation();
    event.preventDefault();
  }
};
window.addEventListener('error', errorHandler);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <SecurityScanner />
  </React.StrictMode>
);
